import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../environments/environment';
import type { CompanyByDomainResponse } from '../models/company-by-domain.model';
import { LS_COMPANY_LOGO_PAYLOAD } from '../storage/session-keys';

@Injectable({ providedIn: 'root' })
export class MasterCompanyService {
  private readonly http = inject(HttpClient);
  private domainPromise: Promise<CompanyByDomainResponse> | null = null;

  /**
   * Resposta completa de GET /company/domain?domain=master (cacheada).
   * Persiste `logo` em localStorage para uso após login em GET /company/avatars/:logo
   */
  getMasterCompanyDomain(): Promise<CompanyByDomainResponse> {
    if (this.domainPromise) {
      return this.domainPromise;
    }

    const url = `${environment.apiBaseUrl}/company/domain`;

    this.domainPromise = firstValueFrom(
      this.http.get<CompanyByDomainResponse>(url, {
        params: { domain: 'master' },
      }),
    )
      .then((body) => {
        const id = body?.id;
        if (!id || typeof id !== 'string') {
          throw new Error('Resposta da API sem id de empresa.');
        }
        if (typeof body.logo === 'string' && body.logo.length > 0) {
          localStorage.setItem(LS_COMPANY_LOGO_PAYLOAD, body.logo);
        }
        return body;
      })
      .catch((err: unknown) => {
        this.domainPromise = null;
        return Promise.reject(err);
      });

    return this.domainPromise;
  }

  /**
   * ID da empresa do domínio `master`.
   */
  getMasterCompanyId(): Promise<string> {
    return this.getMasterCompanyDomain().then((b) => b.id);
  }

  clearCache(): void {
    this.domainPromise = null;
  }
}
